import { GlobalBasePrivilegePipe } from './global-base.pipe';
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'globalAdminPrivilege' })
export class GlobalAdminPrivilegePipe extends GlobalBasePrivilegePipe implements PipeTransform {
    constructor() {
        super('admin');
    }
}
